module.exports = __webpack_public_path__ + "static/media/sup_com_ind.f21e23e6.png";